import React, { useState, useContext } from 'react';
import useForm from ".././Utils/useForm";
import { PublicPasswordContext } from '../../context/PublicPasswordContext';
import StrengthMeter from './StrengthMeter';
import PublicPassword from '../../services/api/PublicPassword';

const Form = ({ setIsUpdated }) => {

    const { values, handleChange, handleSubmit } = useForm(post);
    const [formErrors, setFormErrors] = useState(false);
    const publicPasswordContext = useContext(PublicPasswordContext);

    function post() {
        if (validatePassword()) {
            const publicPasswordApi = new PublicPassword();
            publicPasswordApi.put(
                publicPasswordContext.customerId,
                publicPasswordContext.customerCode,
                values.password1,
                publicPasswordContext.path
            ).then(response => {
                if (response.status === 200) {
                    setIsUpdated(true);
                } else {
                    setFormErrors('Lösenordet är inte tillräckligt säkert');
                }
            }).catch(error => {
                console.log(error);
            });
        }
    }

    const validatePassword = () => {
        if (values.password1 !== values.password2) {
            setFormErrors('Lösenorden stämmer inte överens');
            return false;
        } else {
            setFormErrors('');
            return true;
        }
    };

    const FormErrors = () => {
        if (formErrors) {
            return (
                <span className="paragraph-regular-14 text-danger">{formErrors}</span>
            );
        } else {
            return null;
        }
    }

    return (
        <div className="container">
            <div className="row mb-2">
                <div className="col-sm-6 offset-sm-3 text-center">
                    <form onSubmit={handleSubmit} className="form-inlin justify-content-center">
                        <div className="form-group">
                            <input
                                key="password1"
                                type="password"
                                required
                                placeholder="Ange lösenord"
                                autoComplete="off"
                                name="password1"
                                className={`form-control ${formErrors ? 'is-invalid' : ''}`}
                                value={values.password1 || ''}
                                onChange={handleChange} />
                        </div>
                        <div className="form-group">
                            <input
                                key="password2"
                                type="password"
                                required
                                placeholder="Ange lösenord igen"
                                autoComplete="off"
                                name="password2"
                                className={`form-control ${formErrors ? 'is-invalid' : ''}`}
                                value={values.password2 || ''}
                                onChange={handleChange} />
                        </div>
                        <div className="form-group">
                            <FormErrors />
                        </div>
                        <div className="form-group">
                            <StrengthMeter password={values.password1} />
                        </div>
                        <div className="form-group mt-3">
                            <button
                                type="submit"
                                className="btn btn-primary custom-btn"
                                style={publicPasswordContext.style.button}>
                                Spara
                        </button>
                        </div>
                    </form >
                </div>
            </div>
        </div>
    );
}

export default Form;